import { useEffect, useMemo } from 'react';
import ObjectWidget from '@plone/volto/components/manage/Widgets/ObjectWidget';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getSiorgOrgansList } from '../../actions/siorg/siorg';

const messages = defineMessages({
  organId: {
    id: 'Organ ID',
    defaultMessage: 'Organ ID',
  },
  organIdDescription: {
    id: 'Stores the Organ ID to be used in the Site search.',
    defaultMessage: 'Stores the Organ ID to be used in the Site search.',
  },
});

const SiorgWidget = (props) => {
  const intl = useIntl();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSiorgOrgansList());
  }, [dispatch]);

  const data = useSelector((state) => state.siorg_organs_list?.data);
  // Memoiza o array para não criar nova referência a cada render
  const organs = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  const itemSchema = useMemo(() => {
    return {
      title: props.title,
      required: [],
      properties: {
        name: {
          title: props.title,
          description: props.description,
          default: null,
          type: 'string',
          factory: 'Choice',
          choices: organs.map((organ) => [organ.name, organ.name]),
        },
        organ_id: {
          title: intl.formatMessage(messages.organId),
          description: intl.formatMessage(messages.organIdDescription),
          readOnly: true,
        },
      },
      fieldsets: [
        {
          id: 'default',
          title: props.title,
          fields: ['name', 'organ_id'],
        },
      ],
    };
  }, [intl, organs, props.title, props.description]);

  const onChange = (id, selected) => {
    props.onChange(
      id,
      organs.find((item) => item.name === selected.name),
    );
  };
  return <ObjectWidget schema={itemSchema} {...props} onChange={onChange} />;
};

export default SiorgWidget;
